export const PROMO_CMS_PATHNAME = `promo`;
export const PROMO_CMS_ROOT_PATH = `/${PROMO_CMS_PATHNAME}/:tournament`;
export const PROMO_CMS_TABLES_PATH = `${PROMO_CMS_ROOT_PATH}/tabulky`;
export const PROMO_CMS_SCHEDULE_PATH = `${PROMO_CMS_ROOT_PATH}/program`;
export const PROMO_CMS_BETS_PATH = `${PROMO_CMS_ROOT_PATH}/kurzy`;

export const MAIN_CONTENT_ID = 'PromoCms';
export const PROMO_DEFAULT_COLOR = '#a00d37';
